<template>
<div class="chapter">
<div class="inner_page">
<a id="pv"></a>
<blockquote class="sink breakafter">
<p class="left ">You must give me the pleasure of seeing what I look like. It would be like hearing one’s voice, seeing oneself walk down the street. You must feel free. I know, for instance, that I was once young; and that I have changed; lost and gained and sometimes strayed, as I have grown older. Show me!</p>
<div class="timebreak "> </div>
<p class="center ">—<em>V.S. Naipaul, in a letter to Paul Theroux</em>,<br/>
<em>April 17, 1970</em></p>
</blockquote>
<a id="pvi"></a>
<a id="pvii"></a>
<blockquote class="sink">
<p class="left ">That one person should wish to arouse in another memories relating to a third person is an obvious paradox. To pursue this paradox freely is the harmless intention of all biography. The fact of my having known Carriego does not, I contend—not in this particular case—modify the difficulty of the undertaking.</p>
<div class="timebreak "> </div>
<p class="center ">—Jorge Luis Borges, <em>Evaristo Carriego</em></p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?2a152ed8